<template>
  <div> 
    <v-row class="mb-4">
      <v-col lg="3" cols="12" v-if="isAdmin || showAllUnities">
        <v-card elevation="2" class="rounded-lg v-card">
          <v-card-text class="d-flex justify-space-between align-center">
            <div class="">
              <h3>Total de <strong>Pacientes ME</strong></h3>
              <p>Atualizado em: {{ atualDateAndHour }}</p>
            </div>
            <v-avatar class="avatar" size="60">
              <span class="" size="30">{{ patienteMe }}</span>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="3" cols="12" v-if="isAdmin || showPCRPatientsData || showAllUnities">
        <v-card elevation="2" class="rounded-lg v-card">
          <v-card-text class="d-flex justify-space-between align-center">
            <div class="">
              <h3>Total de <strong>Pacientes PCR</strong></h3>
              <p>Atualizado em: {{ atualDateAndHour }}</p>
            </div>
            <v-avatar class="avatar" size="60">
              <span class="" size="30">{{ patientePCR }}</span>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="3" cols="12" v-if="isAdmin || showAllUnities">
        <v-card elevation="2" class="rounded-lg v-card">
          <v-card-text class="d-flex justify-space-between align-center">
            <div class="">
              <h3>Total de Transplantes <strong>Efetivados</strong></h3>
              <p>Atualizado em: {{ atualDateAndHour }}</p>
            </div>
            <v-avatar class="avatar" size="60">
              <span class="" size="30">{{ finishedTransplants }}</span>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col lg="3" cols="12" v-if="isAdmin || showAllUnities">
        <v-card elevation="2" class="rounded-lg v-card">
          <v-card-text class="d-flex justify-space-between align-center">
            <div class="">
              <h3>Total de Doações <strong>Pendentes</strong></h3>
              <p>Atualizado em: {{ atualDateAndHour }}</p>
            </div>
            <v-avatar class="avatar" size="60">
              <span class="" size="30">{{ pendingTransplants }}</span>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  getMePatients,
  getPcrPatients,
  getFinishedTransplants,
  getPendingTransplants
} from "@/service/LogsService";
import currentUser from "@/utils/currentUser";
import { profileSlug } from "@/helpers/profileSlug";
export default {
  data: () => ({
    donor: "",
    receiver: "",
    filterUnity: "",
    receptor: "",
    doador: "",
    showWelcomeText: false,
    logForm: {},
    filter: {},
    menu: false,
    patienteMe: 0,
    patientePCR: 0,
    finishedTransplants: 0,
    pendingTransplants: 0,
    atualDateAndHour: new Date().toLocaleString(),
  }),

  mounted() { },

  computed: {
    currentUser() {
      return currentUser.getUserData()
    },

    profile_slug() {
      return profileSlug(this.currentUser.profile)
    },

    isAdmin() {
      return [
        'admin',
        'diretor',
        'plantonista_cet_coset',
        'sesab_coset',
        'tec_central'].includes(this.profile_slug);
    },

    showPCRPatientsData() {
      return this.currentUser.abilities?.includes('list_pcr_donor_data')
    },

    showAllUnities() {
      return this.currentUser.abilities?.includes('list_all_unities')
    },
  },

  async created() {
    this.loading = true;

    const unity = this.$store.state.unity_id;

    this.patienteMe = await getMePatients(unity, this.$store);
    this.patienteMe = this.patienteMe.length;

    this.patientePCR = await getPcrPatients(unity, this.$store);
    this.patientePCR = this.patientePCR.length;

    this.finishedTransplants = await getFinishedTransplants(unity, this.$store);
    this.finishedTransplants = this.finishedTransplants.length;

    this.pendingTransplants = await getPendingTransplants(unity, this.$store);
    this.pendingTransplants = this.pendingTransplants.length;
  },

  components: {},

  methods: {}
};
</script>

<style scoped>
.v-card {
  position: relative;
  overflow: hidden;
  height: 180px;
  display: flex;
  border-radius: 8px !important;
  background-color: #f5f7f5;
  cursor: pointer;

  transition:
    background-color 0.35s ease,
    transform 0.35s ease,
    box-shadow 0.35s ease;
}

.v-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 70%;
  height: 100%;
  background: linear-gradient(90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent);
  transition: left 0.6s ease;
}

.v-card:hover {
  background-color: #defde7b3;
  transform: translateY(-6px);
  box-shadow: 0 12px 24px rgba(106, 124, 110, 0.15);
}

.v-card:hover::before {
  left: 150%;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}

.card-chart {
  border: 1px solid salmon !important;
  border-radius: 8px !important;
}

.v-card {
  border-radius: 8px !important;
  background-color: #f5f7f5;
}

.avatar {
  background-color: #0e511a !important;
}

.avatar>span {
  font-size: 15px;
  color: #ffffff !important;
  font-weight: 500 !important;
}
</style>
